export function shouldApplyThreadResult(
  requestId: number,
  currentRequestId: number,
  cancelled: boolean,
): boolean {
  return !cancelled && requestId === currentRequestId;
}
